import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "We listen first",
    body: "Every journey begins with a conversation, not a catalogue. Your budget, your pace, your idea of perfect — that's the brief.",
  },
  {
    n: "02",
    title: "We craft by hand",
    body: "Stays, flights, coaches and experiences are stitched together personally. No copy-paste itineraries, ever.",
  },
  {
    n: "03",
    title: "We quote honestly",
    body: "Prices are shared over a call or message — transparent, all-inclusive, and tailored to the season you travel in.",
  },
];

export const Manifesto = () => (
  <section className="relative py-28 lg:py-36" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-teal-300 tracking-[0.3em] text-xs uppercase mb-16"
      >
        The DX way
      </motion.p>

      <div className="space-y-0">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group grid md:grid-cols-[140px_1fr_1.2fr] gap-6 md:gap-12 items-baseline border-t border-white/10 py-12 transition-colors duration-500 hover:border-teal-400/30"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span className="font-serif text-5xl md:text-6xl text-outline transition-colors duration-500 group-hover:text-teal-300 group-hover:[-webkit-text-stroke:0px]">
              {c.n}
            </span>
            <h3 className="font-serif text-2xl sm:text-3xl tracking-tight">{c.title}</h3>
            <p className="text-base text-slate-400 leading-relaxed">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
